const axios = require("axios");
const Token = {};
const localStorage = window.localStorage;
const yodaURL = process.env.VUE_APP_API_URL;

Token.hasToken = function() {
  return localStorage.getItem("token") ? true : false;
};
Token.getToken = function() {
  return localStorage.getItem("token");
};
Token.setToken = function(token) {
  localStorage.setItem("token", token);
};
Token.setTokenIntegration = async function (token, next) {
    Token.clearToken();
    await axios.post(yodaURL + '/token/decode_token', {token}).then(response => {
        if (response.data.success) {
            // Armazene o token JWT retornado no localStorage
            localStorage.setItem("token", response.data.token);
            next({name: "solicitation"})
        } else {
            Token.clearToken();
            next({name: "notAuthenticated"})
        }
    }).catch(error => {
        next({name: "notAuthenticated"})
        Token.clearToken();
    });
}
Token.clearToken = function() {
  return localStorage.removeItem("token");
};

module.exports = Token;
